import {refreshTokenOnce} from "../auth/tokenRefresh";

// Обновление токена при монтировании App. Используем общий single-flight refresh из index.js:
// раньше здесь шёл второй параллельный forceRefresh (+ свой popup/redirect), что давало двойные
// запросы в Azure на старте и могло запускать несколько redirect-перезагрузок подряд.
export const acquireToken = async (dispatch, msalInstance) => {
    return refreshTokenOnce();
};
